import { Injectable, inject } from '@angular/core';
import { MatDialog as MatDialog, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { SupportModalComponent } from './support-modal.component';
import { ModalSupportData } from './support.model';

@Injectable({
  providedIn: 'root',
})
export class SupportModalService {
  private _dialog = inject(MatDialog);

  openModal(modalData: ModalSupportData): MatDialogRef<any> {
    return this._dialog.open(SupportModalComponent, {
      data: modalData,
      panelClass: ['modal-large'],
    });
  }
}
